


























import { Component, Vue } from 'vue-property-decorator';
import {
  IContractCreate,
} from '@/interfaces';
import { dispatchGetContracts, dispatchCreateContract } from '@/store/contract/actions';

@Component
export default class CreateContract extends Vue {
  public valid = false;
  public clientEmail: string = '';
  public contractComment: string = '';
  public mac: string = '';

  public async mounted() {
    await dispatchGetContracts(this.$store);
    this.reset();
  }

  public reset() {
    this.clientEmail = '';
    this.contractComment = '';
    this.$validator.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$validator.validateAll()) {
      const updatedContract: IContractCreate = {
        client_email: this.clientEmail,
        comment: this.contractComment,
        mac: this.mac,
      };
      if (this.clientEmail) {
        updatedContract.client_email = this.clientEmail;
      }
      if (this.contractComment) {
        updatedContract.comment = this.contractComment;
      }
      await dispatchCreateContract(this.$store, updatedContract);
      this.$router.push('/main/contracts');
    }
  }
}
